import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const pin = localStorage.getItem("host_pin");
  if (pin) config.headers["X-Host-Pin"] = pin;
  return config;
});

export async function downloadCsv(path, filename) {
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 403 && err.response?.data?.detail === "Ongeldige PIN" && localStorage.getItem("host_pin")) {
      localStorage.removeItem("host_pin");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export function wsUrl(gameId) {
  const wsProto = BACKEND_URL.startsWith("https") ? "wss" : "ws";
  const host = BACKEND_URL.replace(/^https?:\/\//, "");
  return `${wsProto}://${host}/api/ws/${gameId}`;
}

export const STAGE_LABELS = {
  row: "1 Volle Rij",
  two_rows: "2 Volle Rijen",
  full: "Volle Kaart (Bingo!)",
};
